import http from "./http";

export const fetchBannerData = () => http.get("/config/banners"); 
export const executeSaveBanner = (credentials) => {
  return http.post(`/config/banners`, credentials) 
}
export const executeUpdateBanner = (id, payload) => {
  return http.patch(`/config/banners/${id}`, payload) 
}